<template>
  <div class="container-header-info">
    <default-header-info v-if="currentTheme === 0 && isHeaderInfo"></default-header-info>

    <div
      class="header-container-info"
      :class="[
        { 'side-nav': isSideNav, ['header-container--' + componentStyle.header]: isHeaderInfo },
      ]"
    >
      <div
        :class="[
          'desktop-header d-none d-lg-block ',
          { 'header-background': isHeaderInfo },
          { 'header-margin': currentTheme > 0 },
          { 'header-default-content': currentTheme === 0 },
        ]"
        v-if="currentTheme > 0"
      >
        <header-info></header-info>
      </div>
      <div
        class="mobile-header d-lg-none"
        :class="[
          {
            'header-position': isHeaderInfo,
            'default-header-position': currentTheme === 0 && isHeaderInfo,
          },
        ]"
      >
        <nav class="navbar navbar-expand-lg navbar-light">
          <div class="navbar-brand" @click="goToHomePage"
               v-show="isFullWidth || isHeaderInfo"
          >
            <span class="logo-container">
              <img :src="getLogo" class="image_base64" alt="UBP Logo" />
            </span>
          </div>
          <div v-if="isHeaderInfo && isSearchInputVisible" class="search-input-container">

            <search-bar
              :in-submit="search"
              :placeholder="$t('buttons.search')"
              :title="title"
              :input="title"
              v-model="title"
              @changed="keywordChanged"
              @blurred="searchInputBlurred"
            ></search-bar>
          </div>
          <div class="buttons-nav-container">
            <b-dropdown
              class="dropdown-lang"
              v-has-permission="'videos_multiple_languages'"
              v-if="showLang"
              v-model="selectedLang"
            >
              <div slot="button-content" class="dropdown-image">
                <img class="image_base64" :src="selectedLang.image" />
                <span class="dropdown-text lang-current">{{ selectedLang.text }}</span>
              </div>
              <b-dropdown-item
                v-for="option in langs"
                :key="option.value"
                :value="option.value"
                @click="changeLang(option)"
              >
                <img :src="option.image" class="image_base64" />
                <span class="dropdown-text">{{ option.text }}</span>
              </b-dropdown-item>
            </b-dropdown>
            <button
              :class="['btn btn-link search-input-toggler']"
              type="button"
              @click="toggleSearchInput()"
            >
              <span class="icon search" v-if="!isSearchInputVisible"></span>
              <span class="icon toggle" v-if="isSearchInputVisible && !!keyword"></span>
            </button>

            <button
              ref="navbarToggler"
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbar"
              aria-controls="navbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="changeIndexDefaultTitle"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>

          <div class="collapse navbar-collapse" id="navbar">
            <ul class="navbar-nav mr-auto">
              <item-list></item-list>
            </ul>
            <div class="mobileLiveButton btnLive d-flex" @click="redirectLive" v-if="!isHeaderInfo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#ff0000"
                width="24px"
                height="24px"
                viewBox="0 0 437.274 318.75"
                style="margin-right: 0.5em;"
              >
                <g id="noun_live_2146916" transform="translate(-2.5 -15.35)">
                  <g id="btnLiveGroupe" data-name="Groupe 2" transform="translate(2.5 15.35)">
                    <path
                      class="big-arc"
                      d="M105.4,20.183c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a186.286,186.286,0,0,1,54.314,132.1A183.759,183.759,0,0,1,82.383,306.483c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,216.869,216.869,0,0,0,63.98-154.657C169.378,116.383,146.823,61.149,105.4,20.183Z"
                      transform="translate(267.897 -15.35)"
                      fill="#ffffff"
                    />
                    <path
                      class="big-arc"
                      d="M34.72,174.48c0-50.171,19.332-96.661,54.774-131.643,6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0C25.054,60.788,2.5,116.023,2.5,174.48A216.869,216.869,0,0,0,66.48,329.137a16.685,16.685,0,0,0,23.014,0c6.444-6.444,6.444-16.57,0-22.554A185.6,185.6,0,0,1,34.72,174.48Z"
                      transform="translate(-2.5 -14.99)"
                      fill="#ffffff"
                    />
                    <path
                      class="small-arc"
                      d="M93.237,31.983c-6.444-6.444-16.57-6.444-22.554,0-6.444,6.444-6.444,16.57,0,22.554a109.053,109.053,0,0,1,32.22,77.329,109.052,109.052,0,0,1-32.22,77.328c-6.444,6.444-6.444,16.57,0,22.554a16.685,16.685,0,0,0,23.014,0,140.318,140.318,0,0,0,41.426-99.883A143.53,143.53,0,0,0,93.237,31.983Z"
                      transform="translate(225.743 27.164)"
                      fill="#ffffff"
                    />
                    <path
                      class="small-arc"
                      d="M51.06,131.966A108.261,108.261,0,0,1,83.28,54.637c6.444-6.444,6.444-16.57,0-22.554-6.444-6.444-16.57-6.444-22.554,0a141.684,141.684,0,0,0,.46,200.686A16.112,16.112,0,0,0,84.2,210.215,109.078,109.078,0,0,1,51.06,131.966Z"
                      transform="translate(58.029 27.524)"
                      fill="#ffffff"
                    />
                    <path
                      d="M63.654,38.836A14.481,14.481,0,0,0,41.1,50.8V147a14.481,14.481,0,0,0,22.554,11.967l72.265-48.33a14.621,14.621,0,0,0,0-24.4Z"
                      transform="translate(136.571 60.356)"
                    />
                  </g>
                </g>
              </svg>
              Live
            </div>
          </div>
        </nav>
        <div v-if="currentTheme > 0">
          <header-info :class="[{ 'header-background': isHeaderInfo }]"></header-info>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import SearchBar from '~/node_modules/search-bar/src/components/Component.vue';
// import ListItems from '~/node_modules/list-items/src/components/Component.vue';
import ItemList from './ItemsList';
import Mixin from '@/mixins/Mixin';
import HeaderInfo from './HeaderInfo';
import DefaultHeaderInfo from './DefaultHeaderInfo';

import HasPermission from '../directives/HasPermission.js';

export default {
  name: 'HeaderContentInfo',
  components: {
    SearchBar,
    ItemList,
    HeaderInfo,
    DefaultHeaderInfo,
  },
  mixins: [Mixin],
  directives: {
    HasPermission,
  },
  data() {
    return {
      isSearchInputVisible: false,
      title: '',
      selectedLang: {},
      langs: [
        {
          value: 'fr',
          text: 'FR',
          image:
            'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6IzQxNDc5QjsiIGQ9Ik0xNzAuNjY3LDQyMy43MjFIOC44MjhjLTQuODc1LDAtOC44MjgtMy45NTMtOC44MjgtOC44MjhWOTcuMWMwLTQuODc1LDMuOTUzLTguODI4LDguODI4LTguODI4ICBoMTYxLjgzOVY0MjMuNzIxeiIvPgo8cmVjdCB4PSIxNzAuNjciIHk9Ijg4LjI3NyIgc3R5bGU9ImZpbGw6I0Y1RjVGNTsiIHdpZHRoPSIxNzAuNjciIGhlaWdodD0iMzM1LjQ1Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGRjRCNTU7IiBkPSJNNTAzLjE3Miw0MjMuNzIxSDM0MS4zMzNWODguMjczaDE2MS44MzljNC44NzUsMCw4LjgyOCwzLjk1Myw4LjgyOCw4LjgyOHYzMTcuNzkzICBDNTEyLDQxOS43Nyw1MDguMDQ3LDQyMy43MjEsNTAzLjE3Miw0MjMuNzIxeiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K',
        },
        {
          value: 'en',
          text: 'EN',
          image:
            'data:image/svg+xml;utf8;base64,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',
        },
      ],
      showLang: false,
    };
  },
  watch: {
    keyword(newVal) {
      this.title = newVal;
    },
    currentTheme(themeId) {
      if (themeId > 0) {
        this.setCurrentThemeDetails(themeId);
      }
    },
  },
  computed: {
    ...mapGetters({
      items: 'themes/getAllThemes',
      currentIdTheme: 'videos/getCurrentTheme',
      currentCategory: 'videos/getCurrentCategory',
      keyword: 'videos/getKeyword',
      live: 'live/getLive',
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      currentLogo: 'layout/getCurrentLogo',
      componentStyle: 'layout/getComponentStyle',
      isHeaderInfo: 'layout/isHeaderInfo',
      currentTheme: 'videos/getCurrentTheme',
    }),
    getLogo() {
      return this.currentLogo ? this.currentLogo : './static/logo.png';
    },
  },
  props: {
    query: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions('videos', ['setKeyword', 'setCurrentCategory']),
    ...mapActions('themes', ['fetchThemes', 'setCurrentThemeDetails']),
    search(keyword) {
        this.title = keyword;
      this.setKeyword(keyword);
      this.$router.push({ name: 'home', params: { category: 'all' } });
      if (keyword !== '') {
        this.$router.push({ query: { q: keyword } });
      }
    },
    redirectLive() {
      location.replace(
        this.live && this.live.permalien_live
          ? this.live.permalien_live
          : 'https://ubp.webtv-solution.com/webinar/ended',
      );
    },
    keywordChanged(keyword) {
      // this.setKeyword(keyword);
    },
    searchInputBlurred(keyword) {
      this.isSearchInputVisible = !!keyword;
    },
    toggleSearchInput() {
      this.isSearchInputVisible = !this.isSearchInputVisible;
    },
    getSearchWord() {
      const query = this.$route.query.q;
      if (query) {
        this.setKeyword(query);
        this.title = query;
      }
    },
    toggleNavbar(id, category) {
      this.itemClicked(id, category);
      this.$refs.navbarToggler.click();
      this.changeIndexDefaultTitle();
    },
    changeIndexDefaultTitle() {
      let headerDefaultInfo = document.querySelector('.header-title');
      let navbar = document.getElementById('navbar');
      var mobileHeader = document.querySelector('.mobile-header');
      let mobileHeaderHeight = mobileHeader.offsetHeight;
      let scrollPosition = Math.round(window.scrollY);
      if (navbar.classList.contains('show')) {
        if (scrollPosition > mobileHeaderHeight && headerDefaultInfo) {
          if (headerDefaultInfo.classList.contains('position-scroll')) {
            headerDefaultInfo.classList.remove('position-scroll');
          } else {
            headerDefaultInfo.classList.add('position-scroll');
          }
        }
      } else {
        if (scrollPosition > mobileHeaderHeight && headerDefaultInfo) {
          if (headerDefaultInfo.classList.contains('position-scroll')) {
            headerDefaultInfo.classList.remove('position-scroll');
          } else {
            headerDefaultInfo.classList.add('position-scroll');
          }
        }
      }
    },
    changeLang(lang) {
      this.selectedLang = lang;
      this.$root.$i18n.locale = this.selectedLang.value;
      localStorage.setItem('lang-fo', this.selectedLang.value);
    },
    setCategory(category) {
      this.setCurrentCategory(category);
      this.toggleNavbar(0, category);
    },
    updateCurrentLanguage() {
      const userLang = localStorage.getItem('lang-fo');
      this.selectedLang = this.langs.find(l => l.value === userLang);
    },
    updatePositionHeader() {
      var header = document.querySelector('.header-container-info');
      var mobileHeader = document.querySelector('.mobile-header');
      var headerDesktop = document.querySelector('.desktop-header');
      var headerContainer = document.querySelector('.container-header');
      var container = document.querySelector('.container-info');
      let mobileVersion = window.innerWidth;
      let mobileHeaderHeight = mobileHeader.offsetHeight;
      let headerDesktopHeight = headerDesktop.offsetHeight;
      let scrollPosition = Math.round(window.scrollY);
      if (scrollPosition > mobileHeaderHeight || scrollPosition > headerDesktopHeight) {
        header.classList.add('header-position-scroll');
        headerDesktop.classList.remove('header-margin');
        headerContainer.classList.add('position-scroll');
      } else {
        header.classList.remove('header-position-scroll');
        headerDesktop.classList.add('header-margin');
        headerContainer.classList.add('position-scroll');
      }
    },
  },
  created() {
    this.updateCurrentLanguage();
  },
  mounted() {
    let self = this;
    this.getSearchWord();
    this.$root.$on('toggleNavbar', () => {
      this.$refs.navbarToggler.click();
      this.changeIndexDefaultTitle();
    });
    this.updatePositionHeader();
    window.addEventListener('scroll', function() {
      self.updatePositionHeader();
    });
    window.addEventListener('resize', function() {
      self.updatePositionHeader();
    });
  },
};
</script>

<!--SHOULD BE NOT SCOPED-->
<style lang="scss">
@import '../assets/scss/_variables.scss';
@import 'src/assets/scss/logo';

%search-input-shared {
  .search-input-container {
    flex: 1 0 0;
    &.full-width {
      padding: 1rem 16px 0 4rem;
    }
    &.side-nav {
      padding: 1rem 7rem 0 0;
      position: relative;
      .btnLive {
        position: absolute;
        right: 0;
        top: 0;
        margin: 1rem 0 0;
        font-weight: 500;
        color: var(--primary-color);
        svg path {
          fill: var(--primary-color);
        }
      }
    }
    .search-bar-container {
      --search-bar-input-width: 99%;
      --search-bar-input-height: 2.5em;
      --search-bar-input-border: none;
      --search-bar-input-radius: none;
      --search-bar-input-bg: transparent;
      --search-bar-btn-border: none;
      --search-bar-btn-bg: transparent;
      --search-bar-input-border-top: none;
      --search-bar-input-border-right: none;
      --search-bar-input-border-left: none;
      --search-bar-btn-radius: 0;
      --search-bar-btn-border-top: none;
      --search-bar-btn-border-right: none;
      --search-bar-btn-border-left: none;
      --search-bar-btn-float: left;
      --search-bar-input-text-size: 1rem;
      --search-bar-placeholder-color: #555555;
      --search-bar-input-text-color: #333;
      --search-bar-input-text-padding: 0 0 0 0.5em;
    }

    .search-bar {
      --search-bar-input-text-width: 95%;
      --search-bar-input-placeholder-color: #8e8e8e;
    }

    .icon {
      --search-bar-icon-width: 1em;
      --search-bar-icon-height: 1.5em;
      --search-bar-icon-color: #8e8e8e;
    }
  }
}
%header-content-info {
  .header-input-container {
    display: flex;
    flex-direction: column;
    font-size: 1em;
    color: #fff;
    width: 100%;
    justify-content: flex-start;
    padding: 0.5em 0;
    text-align: center;
    margin: 0;
    .info-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 0.5em 0;
      .info-subtitle {
        font-size: 1.2em;
        padding-right: 2em;
        text-align: center;
        align-items: center;
        margin: 0;
      }
      .info-nbVideos {
        border: 1px solid transparent;
        background-color: darken($primary-color, 10%);
        border-radius: 5px;
        padding: 0.1em 0.5em;
        font-size: 0.8em;
      }
    }
    .info-description {
      font-size: 1em;
      font-weight: 400;
    }
  }
}
%header-background {
  &.header-background {
    background-color: #{var(--primary-color)};
    width: 100%;
    max-width: 100%;
  }
  &.header-margin {
    top: 2.3125rem;
    margin-top: 2.3125rem;
  }
  .header-background {
    background-color: #{var(--primary-color)};
    margin: 0;
    top: 2.3125rem;
    width: 100%;
    max-width: 100%;
  }
}
.header-container-info {
  position: sticky;
  top: 0;
  z-index: 1002; // Player control-bar
  background: #ffffff;
  //margin: 0 -15px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05), inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  &.header-position-scroll {
    position: fixed;
    width: 100%;
    margin: 0;
    .mobile-version{
      top: 1em;
    }
  }
  &.header-background {
    background-color: #{var(--primary-color)};
    margin: 2.3125rem -15px;
    top: 2.3125rem;
    width: 100%;
    max-width: 100%;
  }
  &.side-nav {
    /*padding: 0 15px;*/
  }
  .desktop-header {
    @extend %search-input-shared;
    @extend %header-background;
    .navbar-brand {
      padding: 0;
      margin-right: 0!important;
      margin-left: 5px
    }
    .list-items {
      --list-items-bg-color: var(--primary-color);
      .list-ul {
        display: flex;
        align-items: center;
        justify-content: start;
        --list-items-list-ul-bg-color: var(--primary-color);
        --list-ul-padding: 0.5em 15px;
        .list-li {
          position: relative;
          --list-number-items: 3.5;
          &:first-child {
            width: 2em;
            .item-name {
              display: none;
            }
            .activeBtn {
              background-color: var(--primary-color) !important;
            }
            .item:hover {
              background-color: var(--primary-color) !important;
            }
          }
          &:not(:first-child) {
            /*flex: 1 0 0;*/
            &:after {
              content: '';
              position: absolute;
              left: 0;
              top: calc(50% - 0.5em);
              height: 1em;
              border-right: 1px solid rgba(255, 255, 255, 0.4);
            }
            .item-icon-container {
              display: none;
            }
          }
          .item {
            --list-items-item-width: 100%;
            --list-items-item-padding: 0.2em 0;
            --list-items-item-name-color: #ffffff;
            --list-items-item-margin: 0;
            --list-items-item-over-textcolor: #ffffff;
            --list-items-item-over: rgba(255, 255, 255, 0.5);
            --list-items-item-border-radius: 0;
            --list-items-item-font-size: 0.9rem;
            &.activeBtn {
              background-color: #ffffff;
              --list-items-item-name-color: #19589e !important;
              .item-name {
                color: var(--primary-color);
              }
            }
            .item-icon-container {
              padding: 0.5em;
              --list-items-item-icon-container-margin: -0.5em 0 0 0.12em;
              --list-items-item-icon-container-height: 2.2em;
              svg {
                width: 1.2em;
                height: 1.2em;
              }
            }
            .item-name {
              font-weight: 700;
              --list-items-item-name-margin: 0.1em auto;
              --list-items-item-name-width: auto;
              --list-items-item-name-padding: 0 0.2em;
            }
          }
        }
      }
    }
    @extend %header-content-info;
  }
  .mobile-header {
    /*padding: 0 14px;*/
    width: 100%;
    padding: 0;
    margin: 0;
    &.header-position {
      position: fixed;
      top: 0;
      background-color: white;
    }
    &.default-header-position {
      position: fixed;
    }
    .logo-container {
      img {
        width: 35px;
        height: auto;
        margin-right: 1em;
      }
    }
    .navbar-toggler {
      border: none;
      padding: 0!important;
      @media screen and (max-width: 768px){
        padding: .25rem 0rem !important;
      }
      .buttons-nav-container {
        display: flex;
        .search-input-toggler {
          right: 0;
        }
      }
    }
    @extend %search-input-shared;
    @extend %header-background;
    .search-input-container {
      background-color: white;
      right: 4em;
      top: 0.5em;
      width: 0;
      padding: 0;
      overflow: hidden;
      transition: all 0.3s ease;
      &.in {
        padding: 0 0 0 2em;
        width: calc(100vw - 4em);
      }
      .icon {
        display: none;
      }
    }
    .search-input-toggler {
      right: 4em;
      top: 1em;
      .icon {
        display: block;
        width: 1em;
        height: 1em;
        background-size: contain;
        background: no-repeat center;
        &.search {
          background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDMwLjIzOSAzMC4yMzkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMwLjIzOSAzMC4yMzk7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNMjAuMTk0LDMuNDZjLTQuNjEzLTQuNjEzLTEyLjEyMS00LjYxMy0xNi43MzQsMGMtNC42MTIsNC42MTQtNC42MTIsMTIuMTIxLDAsMTYuNzM1ICAgYzQuMTA4LDQuMTA3LDEwLjUwNiw0LjU0NywxNS4xMTYsMS4zNGMwLjA5NywwLjQ1OSwwLjMxOSwwLjg5NywwLjY3NiwxLjI1NGw2LjcxOCw2LjcxOGMwLjk3OSwwLjk3NywyLjU2MSwwLjk3NywzLjUzNSwwICAgYzAuOTc4LTAuOTc4LDAuOTc4LTIuNTYsMC0zLjUzNWwtNi43MTgtNi43MmMtMC4zNTUtMC4zNTQtMC43OTQtMC41NzctMS4yNTMtMC42NzRDMjQuNzQzLDEzLjk2NywyNC4zMDMsNy41NywyMC4xOTQsMy40NnogICAgTTE4LjA3MywxOC4wNzRjLTMuNDQ0LDMuNDQ0LTkuMDQ5LDMuNDQ0LTEyLjQ5MiwwYy0zLjQ0Mi0zLjQ0NC0zLjQ0Mi05LjA0OCwwLTEyLjQ5MmMzLjQ0My0zLjQ0Myw5LjA0OC0zLjQ0MywxMi40OTIsMCAgIEMyMS41MTcsOS4wMjYsMjEuNTE3LDE0LjYzLDE4LjA3MywxOC4wNzR6IiBmaWxsPSIjOGU4ZThlIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
        }
        &.toggle {
          background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDIxMi45ODIgMjEyLjk4MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEyLjk4MiAyMTIuOTgyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCI+CjxnIGlkPSJDbG9zZSI+Cgk8cGF0aCBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7IiBkPSJNMTMxLjgwNCwxMDYuNDkxbDc1LjkzNi03NS45MzZjNi45OS02Ljk5LDYuOTktMTguMzIzLDAtMjUuMzEyICAgYy02Ljk5LTYuOTktMTguMzIyLTYuOTktMjUuMzEyLDBsLTc1LjkzNyw3NS45MzdMMzAuNTU0LDUuMjQyYy02Ljk5LTYuOTktMTguMzIyLTYuOTktMjUuMzEyLDBjLTYuOTg5LDYuOTktNi45ODksMTguMzIzLDAsMjUuMzEyICAgbDc1LjkzNyw3NS45MzZMNS4yNDIsMTgyLjQyN2MtNi45ODksNi45OS02Ljk4OSwxOC4zMjMsMCwyNS4zMTJjNi45OSw2Ljk5LDE4LjMyMiw2Ljk5LDI1LjMxMiwwbDc1LjkzNy03NS45MzdsNzUuOTM3LDc1LjkzNyAgIGM2Ljk4OSw2Ljk5LDE4LjMyMiw2Ljk5LDI1LjMxMiwwYzYuOTktNi45OSw2Ljk5LTE4LjMyMiwwLTI1LjMxMkwxMzEuODA0LDEwNi40OTF6IiBmaWxsPSIjOGU4ZThlIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
        }
      }
    }
    .dropdown-lang {
      margin-top: 5px;
    }
    @extend %header-content-info;
  }
}

nav.navbar {
  padding: 0.5rem 5px!important;
}
.navbarList {
  display: flex;
  width: 100%;
  padding-right: 25px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.list-items {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.nav-link {
  &.router-link-active {
    color: var(--primary-color) !important;
  }
}

@media (max-width: 575px) {
  .header-container-info {
    // margin: 0 -15px;
    &--info {
      margin: 0;
    }
  }
  .container {
  //  padding-right: 0;
   // padding-left: 0;
  }
}
@media (min-width: 576px) {
  .container {
    max-width: 100%;
  }
}
@media (min-width: 992px) {
  .navbarList {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container,
  .navbarList {
    max-width: 1200px !important; //1180px !important;
    &.container-header {
      &.position-scroll {
        margin: 0;
      }
    }
  }
}
@media (min-width: 1400px) {
  .container,
  .navbarList {
    max-width: 1400px !important; //1180px !important;
    &.container-header {
      &.position-scroll {
        margin: 0;
      }
    }
  }
}
@media (min-width: 1600px) {
  .container,
  .navbarList {
    max-width: 1600px !important;
    &.container-header {
      &.position-scroll {
        margin: 0;
      }
    }
  }
}

.navbar-container {
  background-color: var(--primary-color);
  display: flex;
  justify-content: center;
}

/*
   * IE 11 Support
   */

.search-bar-container {
  width: 100%;
  height: inherit;
  border-top: 2.5em;
  border-right: none;
  border-bottom: 1px solid #c4c5c6;
  border-left: none;
  border-radius: 0;
  background: transparent;
  opacity: 1;
  padding: 10px;
  outline: none;
}

.search-bar {
  width: 95%;
  color: #333;
  padding: 0 0 0 0.5em;
  font-size: 1rem;
}

.header-container-info .icon {
  width: 1em;
  height: 1.5em;
  color: #8e8e8e;
  float: left;
}

.list-items {
  background-color: var(--primary-color);
  font-family: var(--list-items-font-family, sans-serif);
}

.list-ul {
  list-style-type: none;
  overflow: visible !important;
  margin: 0;
  padding: 0.5em 15px;
  background-color: var(--primary-color);
  width: 100%;
  vertical-align: middle;
}

.list-li {
  height: 100%;
  display: inline-block;
}
.btnLive {
  display: flex;
  align-items: center !important;
  border-radius: unset !important;
  color: #fff;

  svg path {
    fill: #fff;
  }
  #btnLiveGroupe {
    .big-arc {
      animation: hideShow 2s 1.5s ease infinite;
    }
    .small-arc {
      animation: hideShow 2s 1s ease infinite;
    }
  }
  &:disabled,
  &[disabled] {
    background: #407156 !important;
    border-color: #407156 !important;
    color: #22503d !important;
    opacity: 1;

    svg path {
      fill: #22503d;
    }
    #btnLiveGroupe {
      .big-arc {
        animation: none;
      }

      .small-arc {
        animation: none;
      }
    }
  }
}

.item {
  float: left;
  text-align: center;
  padding: 0.2em 0;
  font-size: 0.9rem;
  height: 100%;
  margin: 0;
  border-radius: 0;
  width: 100%;
  color: #ffffff;
  &.activeBtn {
    background-color: #ffffff;
    color: var(--primary-color) !important;
    .item-name {
      color: var(--primary-color);
    }
  }
}

.item-icon-container {
  float: left;
  width: 30%;
  height: 2.2em;
  padding: 0;
  margin: -0.5em 0 0 0.12em;
}

.item-icon {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.item-name {
  float: left;
  width: auto;
  margin: 0.1em auto;
  padding: 0 0.2em;
}

.item:hover {
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  color: #fff;
  fill: #fff;
}
.activeBtn {
  background-color: #e3e3e3;
  fill: #fff;
}
.mobileLiveButton {
  cursor: pointer;
  color: var(--primary-color);
  svg path {
    fill: var(--primary-color);
  }
}

@media all and (-ms-high-contrast: none) {
  .color-container {
    display: none !important;
  }
}

@keyframes hideShow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.dropdown-lang {
  transform: translateY(10px);
  .dropdown-toggle,
  .dropdown-toggle:hover,
  .dropdown-toggle.show,
  .dropdown-toggle.active,
  .dropdown-toggle:active {
    background: none !important;
    color: #000 !important;
    border: none !important;
    display: flex;
    flex-direction: row;
    box-shadow: none !important;
  }
  .image_base64 {
    width: 20px;
      cursor: pointer;
  }

  .dropdown-image {
    margin-top: -10px;
  }

  .dropdown-text {
    font-family: sans-serif;
    font-size: 14px;
    font-weight: bold;
    color: #41479b;

    &.lang-current {
      margin-right: 7px;
    }
  }

  .dropdown-menu {
    min-width: 1rem;
  }
}
@media (max-width: 991px) {
  nav.navbar {
    //padding: 0.5rem 0;
  }

  .logo {
    width: $width;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderContentInfo.vue